import { FC } from "react";

import { Box, Stack } from "@mui/material";

import { LiveEditorColorButton } from "../../LiveEditorColorButton/LiveEditorColorButton";

import { useTranslate } from "@/common/hooks/useTranslate";
import { DashboardIcon } from "@/dashboard-design-system/Icon/DashboardIcon";
import { DashboardTypography } from "@/dashboard-design-system/Typography/DashboardTypography";
import { Add, Edit } from "@/icons/outlined";

interface CustomColorTileProps {
  customColor?: string;
  isSelected: boolean;
  onClick: () => void;
}

export const CustomColorTile: FC<CustomColorTileProps> = ({ customColor, isSelected, onClick }) => {
  const { t } = useTranslate();
  const label = t("dashboard", "liveFormEditor.stepColor.customTile");

  return (
    <Stack alignItems="center" gap={1.25}>
      {customColor ? (
        <LiveEditorColorButton
          color={customColor}
          isSelected={isSelected}
          hasSelectedCheck={false}
          onClick={onClick}
          aria-label={label}
          data-test="custom-color-tile"
          badge={
            isSelected ? null : (
              <Box
                sx={{
                  position: "absolute",
                  right: -8,
                  bottom: -8,
                  width: 20,
                  height: 20,
                  borderRadius: "50%",
                  bgcolor: "background.paper",
                  boxShadow: 1,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <DashboardIcon vibe="text-neutral-moderate" size="small">
                  <Edit />
                </DashboardIcon>
              </Box>
            )
          }
        />
      ) : (
        <LiveEditorColorButton
          isSelected={isSelected}
          hasSelectedCheck={false}
          isOutlined
          onClick={onClick}
          aria-label={label}
          data-test="custom-color-tile"
          icon={
            <DashboardIcon vibe="text-neutral-moderate">
              <Add />
            </DashboardIcon>
          }
        />
      )}
      <DashboardTypography variant="caption" vibe="text-neutral-moderate">
        {label}
      </DashboardTypography>
    </Stack>
  );
};
